<template>
    <div class="lottery-header" :class="'lottery-header_' + lottery.type_code">
        <div class="column1 line">
            <img :src="lottery.logo" alt="" class="logo">
            <div class="filter" v-popover:popoverLottery>
                <span>{{lottery.name}}<i class="el-icon-caret-bottom"></i></span>                    
            </div>
        </div>
        <div class="column2 line">
            <p>
                本期第 <b>{{issue.cur_except}}</b> 期 开奖结果
            </p>
            <ul class="balls">
                <li v-for="(item) in issue.cur_codes">
                    <b>{{item}}</b>
                </li>
            </ul>
        </div>
        <div class="column3">
            <p>
                当前在售 <b>{{issue.next_except}}</b> 期距下次开奖时间
            </p>
            <div class="countdown">
                <div class="time">{{remainTime[0]}}</div>
                <span>:</span>
                <div class="time">{{remainTime[1]}}</div>
                <span>:</span>
                <div class="time">{{remainTime[2]}}</div>
                <div class="sound" @click="soundSwitchTo" :class="sound_status ? 'sound-open' : 'sound-close'" :title="sound_status ? '关闭声音' : '开启声音'">
                </div>
            </div>
        </div>

        <el-popover :visible-arrow="false"
                    placement="bottom-start"
                    popper-class="popcon_lottery"
                    ref="popoverLottery"
                    trigger="hover"
                    v-model="popoverLotteryVisible"
                    :offset="0">
            <div class="popcon">
                <div class="item scrollbar" v-for="(item,index) in lotteryList" >
                    <div class="tit">
                        <i></i><span>{{item.name}}</span><i></i>
                    </div>
                    <ul>
                        <li v-for="(it,i) in item.list" >
                            <a href="javascript:;" @click="clickJumpLoty(it)" >{{it.name}}</a>
                        </li>                    
                    </ul>
                </div>
            </div>
        </el-popover>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { getCountIndex } from '@/api/lottery.js';
    import { remain_time } from '@/utils/common.js'
    export default {
        props: ['lottery'],
        data() {
            return {
                lotteryList: [],
                issue: {},
                countdown_timer: null,
                get_code_timer: null,
                popoverLotteryVisible: false,
                countdown_number: 0
            }
        },
        created() {
        },
        watch: {
            lottery_config:{
                handler (val){
                    if (val && val.length > 0) {
                        this.lotteryList = val;
                    }
                },
                immediate: true
            },
            'lottery': {
                handler(val, oldValue) {
                    if(val && val.id) {
                        if(val.logo.indexOf("http") == "-1") {
                            this.lottery.logo = process.env.BASE_IMG + "/" + val.logo;
                        }
                        this.getCountIndex();
                    }
                },
                immediate: true
            },
            sound_status:function (val) {
                if(!val){
                    try {
                        document.getElementById('kaijiang-audio').pause();
                    } catch (error) {
                        console.log('sound_status:',error)
                    }                    
                }
            }
        },
        computed: {
             ...mapGetters(['lottery_config','lottery_all','sound_status','token','expire_time']),
            //倒计时展示
            remainTime: function() {
                let time = remain_time(this.issue.next_time);
                let remain_arr = time.split(':');
                let remain_hour = parseInt(remain_arr[0]) + (remain_arr[3] ? remain_arr[3] : 0) * 24;
                remain_arr[0] = (remain_hour > 9 ? remain_hour : '0' + remain_hour);
                return remain_arr;
            }        
        },
        methods: {
            clickJumpLoty(item) {
                if (this.validateRouter(item.loty)) {
                    if (this.$route.name == "planIndex") {
                        this.$router.push('/plan/' + item.loty)
                    } else {
                        this.$router.push('/index/' + item.loty)
                    }
                }
                this.popoverLotteryVisible = false;
            },
            validateRouter(loty) {
                if(this.lottery_config.length > 0 && this.lottery_config[0].list.length > 0) {
                    let default_loty = this.lottery_config[0].list[0];
                    if (default_loty.loty != loty) {
                        // if (this.token == undefined || this.token == "") {
                            if (0>1) {
                            this.$alert('用户登录查看更多计划!', '提示', {
                                confirmButtonText: '确定',
                                callback: action => {
                                    ;
                                }
                            });
                            return false;
                        } 
                        if (this.token && this.expire_time) {
                            //当前时间戳
                            let now_timestamp = Date.parse(new Date()) / 1000;
                            if(now_timestamp > Number(this.expire_time)) {
                                this.$confirm('会员到期!查看更多计划需要充值会员', '提示', {
                                    confirmButtonText: '充值',
                                    cancelButtonText: '关闭',
                                    type: 'warning'
                                }).then(() => {
                                    this.$router.push('/member/recharge')
                                }).catch(() => {
                                    return false;
                                });
                                return false;
                            }                    
                        }
                    }
                }
                return true;
            },
            clickSound() {
                this.sound_status = !this.sound_status;
            },
            getCountIndex() {
                //彩种倒计时
                getCountIndex(this.lottery.loty).then((response)=>{
                    this.countdown_number++ ;
                    if (response.data.code == 200) {
                        //newest_loty: "20210413041|2,3,6" 最新开奖结果
                        //next_except: "2021041401" //当前可以购买
                        //next_time: 34618; 倒计时
                        let newest_loty = response.data.data.newest_loty;
                        let cur_except = '', cur_codes = [], cur_issue = 0;
                        //当前/最新开奖
                        if(newest_loty) {
                            let cur = newest_loty.split('|');
                            cur_except = cur[0];
                            cur_codes = cur[1].split(',');
                            cur_issue = cur_except.substring(cur_except.length-4,cur_except.length);
                        }

                        //console.log('声音',this.sound_status,this.issue.cur_except,cur_except)
                        //当前奖期 = 不等于上一次奖期
                        if (this.sound_status && this.issue.cur_except && this.issue.cur_except != cur_except){
                            //console.log('声音')
                            try {
                                document.getElementById('kaijiang-audio').play();
                            }catch (e) {
                                console.log(e.toString());
                            }
                        }

                        this.issue = {
                            cur_except: cur_except,
                            cur_codes: cur_codes,
                            next_except: response.data.data.next_except,
                            next_time: response.data.data.next_time
                        };
                        clearInterval(this.countdown_timer);
                        clearInterval(this.get_code_timer);
                        this.countdown_timer = setInterval(this.countDown, 1000);
                        this.get_code_timer = setInterval(this.getCountIndex,this.issue.next_time < 10 ? 3000 : 20000);
                        
                        
                        if(this.$route.name == 'planIndex') {
                            this.$eventBus.$emit('lotteryPlanIssue',{issue:this.issue,countdown: this.countdown_number});
                        } else {
                            this.$eventBus.$emit('lotteryIssue',{issue:this.issue,countdown: this.countdown_number});
                        }
                        
                             
                        //下一期
                        // var expect  = response.data.data.next_except.toString();
                        // var openExp = expect.substring(expect.length-4,expect.length);

                        // var isfirst = openExp.substring(1,10);
                        // if (parseInt(isfirst) != 1) {
	                    //     if (openExp - cur_issue > 1 && this.issue.next_time<1201) {
	                    //         clearTimeout(pouttime);
	                    //         pouttime = null;
	                    //         pouttime = setTimeout(function(){
	                    //             pcountdown();
	                    //             getData()
	                    //         },1000)
	                    //         return false;
	                    //     }
	                    // }

                    }else {
                        clearInterval(this.countdown_timer);
                        clearInterval(this.get_code_timer);
                        this.$message.error(response.data.msg);
                    }
                }).catch((error)=>{
                    this.issue.cur_except = "";
                    this.issue.cur_codes = [];
                    this.issue.next_except = "";
                    this.issue.next_time = 0;
                    clearInterval(this.countdown_timer);
                    clearInterval(this.get_code_timer);
                    this.$message.error("彩种异常");
                })
            },
            countDown() {
                if (this.issue.next_time > 0) {
                    this.issue.next_time--;
                } else {
                    setTimeout(this.getCountIndex(),6000);
                }
            },
            soundSwitchTo: function(value) {
                this.$store.commit('SET_SOUNDSTATUS', !this.sound_status);
            },
        },
        beforeDestroy() {
            //清除定时器
            clearInterval(this.countdown_timer);
            clearInterval(this.get_code_timer);
        }
    }
</script>

<style lang="scss">
.lottery-header {
    height: 120px;
    background: linear-gradient(#BC7B1F, #774C1F);
    border-radius: 10px;
    display: flex;
    .column1 {
        width: 175px;
        text-align: center;
        display: flex;
        flex-flow: column;
        align-items: center;
        justify-content: center;
        .logo {
            max-height: 60px;
        }
        .filter {
            width: 120px;
            line-height: 30px;
            border: 1px solid #B09779;
            color: #ffffff;
            cursor: pointer;
            margin-top: 5px;
            i {
                margin-left: 5px;
            }
        }
    }
    .column2 {
        flex: 1;
        text-align: center;
        p {
            line-height: 35px;
            color: #ffffff;
            b {
                color: #fff14f;
                padding: 0 10px;
            }
        }
        .balls {
            li {
                display: inline-block;
                width: 78px;
                height: 80px;
                line-height: 80px;
                font-weight: bold;
                color: #d23b36;
                font-size: 40px;
                font-family: Arial;
                background-image: url('../../assets/images/num_bg.png');
                background-position: center center;
                background-repeat: no-repeat;
                & + li {
                    margin-left: 15px;
                }
            }
        }
    }
    .column3 {
        width: 358px;
        padding: 0 20px;
        box-sizing: border-box;
        text-align: center;
        p {
            line-height: 35px;
            color: #ffffff;
            b {
                color: #fff14f;
                padding: 0 10px;
            }
        }
        .countdown {      
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 10px;
            .time {
                display: inline-block;
                width: 67px;
                height: 58px;
                line-height: 58px;
                font-weight: bold;
                color: #d23b36;
                font-size: 40px;
                font-family: Arial;
                background-image: url('../../assets/images/time_bg.png');
                background-position: center center;
                background-repeat: no-repeat;                    
            }
            span {
                font-size: 32px;
                width: 26px;
                color: #ffffff;
                text-align: center;
            }
            .sound {
                width: 40px;
                height: 40px;                    
                background-position: center center;
                background-repeat: no-repeat;
                margin-left: 10px;
                cursor: pointer;
                &.sound-open{
                    background-image: url('../../assets/images/sy_open.png');
                }
                &.sound-close{
                    background-image: url('../../assets/images/sy_close.png');
                }
            }
        }
    }
    .line {
        position: relative;
        &::after {
            position: absolute;
            content:  ' ';
            background-image: url('../../assets/images/line.png');
            background-position: center center;
            background-repeat: no-repeat;
            width: 2px;
            top: 0;
            right: 0;
            height: 100%;
        }
    }

    &.lottery-header_pk10 {
        .column2 .balls {
            margin-top: 10px;
            li {
                background-image: url('../../assets/images/num_bg_min.png');
                width: 53px;
                height: 55px;
                line-height: 55px;
                font-size: 26px;
                & + li {
                    margin-left: 2px;
                }
            }
        }
    }

        &.lottery-header_dpc {
        .column2 .balls {
            margin-top: 10px;
            li {
                background-image: url('../../assets/images/num_bg_min.png');
                width: 53px;
                height: 55px;
                line-height: 55px;
                font-size: 26px;
                & + li {
                    margin-left: 2px;
                }
            }
        }
    }
}
.popcon_lottery {
    padding: 0;
    border-radius: 10px;
    box-shadow: 0 4px 10px #ddd;
    position: relative;
    overflow: hidden;
    height: 580px;
    border: 1px solid #dca66b;
    .popcon {
        display: flex;
        height: 100%;
        .item {
            width: 250px;
            text-align: center;
            position: relative;
            &::after {
                position: absolute;
                display: block;
                content: '';
                width: 1px;
                height: 100%;
                right: 0;
                top: 0;
                background: #ddd;
            }
            .tit {
                padding-top: 14px;
                padding-bottom: 4px;
                i {
                    display: inline-block;
                    vertical-align: middle;
                    width: 40px;
                    height: 1px;
                    background: #ddd;
                }
                span {
                    font-size: 20px;
                    color: #88522a;
                    padding: 0 14px;
                    vertical-align: middle;
                    letter-spacing: 1px;
                }
            }
            ul {
                li {
                    height: 40px;
                    line-height: 40px;                    
                    list-style: none;
                    a {
                        display: block;
                        width: 100%;
                        font-size: 16px;
                        color: #333;
                        &:hover {
                            color: #88522a;
                        }
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/common/lotteryHeader.vue